import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Dashboard.css";
import "../Style/Emergency.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AlertCircle,  MapPin, Phone, Map, Building, Save, List, Siren,
  Eye,
  Plus,
} from "lucide-react";

const Emergency = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [emergencyList, setEmergencyList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmergency, setSelectedEmergency] = useState("");
  const [newEmergencyType, setNewEmergencyType] = useState("");
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const [emergencyTypes, setEmergencyTypes] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");

  const [formData, setFormData] = useState({
    dials: "",
    serviceName: "",
    address: "",
    phone: "",
    state: "",
    city: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const societyName = localStorage.getItem("society");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      // setImageURL("");
    }
  };

  const handleSave = async () => {
    if (!newEmergencyType) {
      toast.error("Please enter an emergency type!");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const formData = new FormData();
      formData.append("emergencyType", newEmergencyType);
      formData.append("societyName", societyName);

      if (imageFile) {
        formData.append("emergencyImage", imageFile);
      }

      const response = await axios.post(
        `${BASE_URL}/emergencytype/add-emergencytype`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("Emergency Type saved successfully ");
      setNewEmergencyType("");
      setImageFile(null);
      // setImageURL("");
      setImagePreview("");
      handleCloseModal();
    } catch (error) {
      console.error("Error saving emergency type:", error);
      toast.error("Failed to save emergency type ");
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.dials) newErrors.dials = "Emergency dials is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.phone) newErrors.phone = "Phone is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
     if (!formData.serviceName) newErrors.serviceName = "Service name is required"; 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const formParams = new URLSearchParams();
    formParams.append("dials", formData.dials);
     formParams.append("serviceName", formData.serviceName);
    formParams.append("address", formData.address);
    formParams.append("phone", formData.phone);
    formParams.append("state", formData.state);
    formParams.append("city", formData.city);
    formParams.append("societyName", societyName);

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BASE_URL}/emergency/add-emergency`,
        formParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      toast.success("Emergency added successfully ", {
        position: "bottom-right",
        autoClose: 3000,
      });

      console.log(response.data);
    } catch (error) {
      console.error("Error adding emergency:", error);
      toast.error("Failed to add emergency ", {
        position: "bottom-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const getEmergencyByAdminEmergencyType = async () => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

    try {
      const response = await axios.get(
        `${BASE_URL}/emergency/emergency-filter-by-admin-emergency-type`,
        {
          params: { societyName },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("API Response:", response.data);
      setEmergencyList(response.data); 
    } catch (error) {
      console.error("Error fetching emergency data:", error);
    }
  };

  useEffect(() => {
    getEmergencyByAdminEmergencyType();
  }, []);

  const handleViewAll = () => {
    setShowDropdown(true);
    getEmergencyByAdminEmergencyType();
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedEmergency(value);

    navigate("/emergency-list", {
      state: { emergencyTypeId: value },
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");
    fetch(
      `${BASE_URL}/emergencytype/get-emergency-type?societyName=${societyName}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        return response.json();
      })
      .then((data) => {
        setEmergencyTypes(data);
        console.log("api call here how to call here " + JSON.stringify(data));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [societyName]);

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />
          <div className="emergency-container">
            <div className="emergency-card">
              <div className="emergency-header ">
                <div className="emergency-title-group">
                  <Siren size={28} />
                  <h2>Emergency Contact Form</h2>
                </div>
                <div>
                  <div
                    style={{ display: "inline-flex", alignItems: "center", gap: "10px", 
                      cursor: "pointer", color: "white", }}
                    onClick={handleViewAll}
                  >
                    <Eye size={16} color="white" />
                    <Plus size={16} color="white" onClick={handleOpenModal} />
                  </div>
                  {isModalOpen && (
                    <div
                      style={{
                        position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                        background: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center",
                        alignItems: "center", zIndex: 1000, animation: "fadeIn 0.3s ease",
                      }}
                    >
                      <div
                        style={{ background: "#fff", padding: "30px 25px",
                          borderRadius: "12px",
                          width: "350px",
                          maxWidth: "90%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                          transform: "translateY(0px)",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "20px",
                            textAlign: "center",
                            color: "#333",
                          }}
                        >
                          Add Emergency Type
                        </h3>

                        <input
                          type="text"
                          value={newEmergencyType}
                          onChange={(e) => setNewEmergencyType(e.target.value)}
                          placeholder="Enter Emergency Type"
                          style={{
                            padding: "12px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            fontSize: "14px",
                            outline: "none",
                            transition: "border 0.2s",
                          }}
                          onFocus={(e) =>
                            (e.target.style.border = "1px solid #4CAF50")
                          }
                          onBlur={(e) =>
                            (e.target.style.border = "1px solid #ccc")
                          }
                        />

                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          style={{ padding: "8px 0" }}
                        />
                        {imagePreview && (
                          <img
                            src={imagePreview}
                            alt="Preview"
                            style={{
                              width: "100%",
                              maxHeight: "150px",
                              objectFit: "contain",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                            }}
                          />
                        )}

                        <div
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            onClick={handleSave}
                            style={{
                              flex: 1,
                              padding: "10px 0",
                              borderRadius: "6px",
                              background: "#4CAF50",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.background = "#45a049")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.background = "#4CAF50")
                            }
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCloseModal}
                            style={{
                              flex: 1,
                              padding: "10px 0",
                              borderRadius: "6px",
                              background: "#f44336",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.target.style.background = "#e53935")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.background = "#f44336")
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {showDropdown && (
                    <select
                      style={{ marginTop: "10px", width: "200px" }}
                      value={selectedEmergency}
                      onChange={handleSelectChange}
                    >
                      <option value="">Select Emergency</option>

                      {emergencyList.length > 0 ? (
                        emergencyList.map((item) => (
                          <option key={item.emergency} value={item.emergency}>
                            {item.emergency}
                          </option>
                        ))
                      ) : (
                        <option disabled>No Data Found</option>
                      )}
                    </select>
                  )}
                </div>
              </div>
              <form className="emergency-form-body" onSubmit={handleSubmit}>
                <div className="form-grid-emergency">
                <div className="form-field-emergency">
                  <label className="form-label-emergency">
                    <Building size={16} />
                    <span>Service Name</span>
                    <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="serviceName"
                    value={formData.serviceName}
                    onChange={handleChange}
                    required
                    placeholder="Enter Police Station / Hospital Name"
                    className={`form-input-emergency ${errors.serviceName ? "error" : ""}`}
                  />
                  {errors.serviceName && (
                    <div className="error-message-emergency">
                      {errors.serviceName}
                    </div>
                  )}
                </div>
                  <div className="form-field-emergency">
                    <label className="form-label-emergency">
                      <AlertCircle size={16} />
                      <span>Emergency Type</span>
                      <span className="required">*</span>
                    </label>
                    <select
                      name="dials"
                      value={formData.dials}
                      onChange={handleChange}
                      required
                      className={`form-select-emergency ${errors.dials ? "error" : ""}`}
                    >
                      <option value="">-- Select Emergency Type --</option>
                      <option value="AMBULANCE">AMBULANCE</option>
                      <option value="FIRE BRIGADE">FIRE BRIGADE</option>
                      <option value="HOSPITAL">HOSPITAL</option>
                      <option value="POLICE">POLICE</option>
                      <option value="Women Helpline">Women Helpline</option>
                      <option value="Child Helpline">Child Helpline</option>
                      <option value="Forest">Forest</option>
                      <option value="Gas Leakage (LPG)">
                        Gas Leakage (LPG)
                      </option>

                      {emergencyTypes.map((item) => (
                        <option
                          key={`api-${item.emergencyTypeId}`}
                          value={item.emergencyType}
                        >
                          {item.emergencyType}
                        </option>
                      ))}
                    </select>
                    {errors.dials && (
                      <div className="error-message-emergency">
                        {errors.dials}
                      </div>
                    )}
                  </div>

                  <div className="form-field-emergency">
                    <label className="form-label-emergency">
                      <Building size={16} />
                      <span>City</span>
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      placeholder="Enter city name"
                      className={`form-input-emergency ${errors.city ? "error" : ""}`}
                    />
                    {errors.city && (
                      <div className="error-message-emergency">
                        {errors.city}
                      </div>
                    )}
                  </div>

                  <div className="form-field-emergency">
                    <label className="form-label-emergency">
                      <MapPin size={16} />
                      <span>Address</span>
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                      placeholder="Enter full address"
                      className={`form-input-emergency ${errors.address ? "error" : ""}`}
                    />
                    {errors.address && (
                      <div className="error-message-emergency">
                        {errors.address}
                      </div>
                    )}
                  </div>

                  <div className="form-field-emergency">
                    <label className="form-label-emergency">
                      <Phone size={16} />
                      <span>Phone Number</span>
                      <span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter phone number"
                      className={`form-input-emergency ${errors.phone ? "error" : ""}`}
                    />
                    {errors.phone && (
                      <div className="error-message-emergency">
                        {errors.phone}
                      </div>
                    )}
                  </div>

                  <div className="form-field-emergency full-width-emergency">
                    <label className="form-label-emergency">
                      <Map size={16} />
                      <span>State</span>
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                      placeholder="Enter state name"
                      className={`form-input-emergency ${errors.state ? "error" : ""}`}
                    />
                    {errors.state && (
                      <div className="error-message-emergency">
                        {errors.state}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-actions-emergency">
                  <button
                    type="submit"
                    className="submit-btn-emergency"
                    disabled={loading}
                  >
                    <Save size={18} />
                    <span>
                      {loading ? "Submitting..." : "Add Emergency Contact"}
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Emergency;
